webpackJsonp([270252565601722],{

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Administration = function (_Component) {
	  _inherits(Administration, _Component);
	
	  function Administration() {
	    _classCallCheck(this, Administration);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Administration.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'insid-header activity-header', style: { marginTop: '100px' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'insid-header-text activity-header-text' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'wow fadeIn', 'data-wow-duration': '.2s', 'data-wow-delay': '.1s' },
	                  'Amministrazione e Bilancio'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'activity about2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-lg-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'activity-text wow fadeIn animated', 'data-wow-duration': '.5s', 'data-wow-delay': '.2s' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'activity-h2' },
	                  'Dettagli'
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Valutazione dell\u2019',
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      'organizzazione'
	                    ),
	                    ' amministrativa e check-up del sistema contabile.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Gestione pro-tempore ruolo di CFO e Responsabile Amministrativo.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Assistenza nell\u2019implementazione di sistemi amministrativi evoluti in grado di integrare le esigenze di natura societaria nei confronti dei terzi (azionisti, fisco, banche) con le esigenze di natura informativa del management, ai vari livelli della struttura organizzativa (contabilit\xE0 generale e gestionale).'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Administration;
	}(_react.Component);
	
	exports.default = Administration;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-administration-it-js-126cd6c5094c70057f6c.js